module.exports = __webpack_public_path__ + "static/img/icon_boss.eb565907.png";